export default __webpack_public_path__ + "static/media/avatar5.f02df356.svg";